import loadable from '@loadable/component';

export const InvoicesLinksLoadable = loadable(() => import('./InvoicesLinks'), {
  resolveComponent: (module) => module.InvoiceLinks,
});
